<div class="bg-white rounded">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Registrar Nueva Receta</h4>
            <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="form">
                <div class="form-group col-12 col-lg mb-3">
                    <label for="producto_id">Producto</label>
                    <ng-select [items]="productos" formControlName="producto_id" bindValue="id" labelForId="producto_id"
                        [searchFn]="searchFn" [virtualScroll]="true" [readonly]="form.controls['producto_id'].disabled"
                        bindLabel="nombre">
                        <ng-template ng-label-tmp let-item="item">
                            {{item.nombre}}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            {{item.nombre}}
                        </ng-template>
                    </ng-select>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-sm mb-3">
                        <label for="nombre">Nombre</label>
                        <input type="text" class="form-control" id="nombre" formControlName="nombre"
                            [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                    </div>
                    <div class="form-group col-12 col-sm mb-3">
                        <label for="cantidad">Cantidad Producida</label>
                        <input type="text" class="form-control" id="cantidad" formControlName="cantidad"
                            [ngClass]="{'is-invalid': form.controls['cantidad'].errors && form.controls['cantidad'].touched}"
                            thousandSeparator="." mask="separator.0">
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="form-group col-12 col-lg mb-3">
                        <label for="insumo_id">Insumo</label>
                        <ng-select [items]="insumos" formControlName="insumo_id" bindValue="id" labelForId="insumo_id"
                            [searchFn]="searchFn" [virtualScroll]="true" bindLabel="nombre">
                            <ng-template ng-label-tmp let-item="item">
                                {{item.nombre}}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                {{item.nombre}}
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="form-group col-12 col-lg-3 mb-3">
                        <label for="cantidad_insumo">Cantidad Gastada</label>
                        <input type="text" class="form-control" id="cantidad_insumo" formControlName="cantidad_insumo"
                            thousandSeparator="." mask="separator.0">
                    </div>
                    <button class="btn btn-primary col-lg-4 mb-3 mt-auto" (click)="addInsumo()"><i
                            class="fas fa-plus"></i> Agregar ingrediente</button>
                </div>
                <kuv-table [useFilter]="false" [usePagination]="false" [items]="tableItems" [columns]="tableColumns"
                    [actions]="tableActions"></kuv-table>
            </form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="completarRegistro()">Guardar</button>
            <button type="button" class="btn btn-secondary"
                (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
        </div>
    </div>
</div>